import commonStyles from "styles/common";
import viewsStyles from "styles/views";
//import { tss } from "tss-react";
//import { getCachedData } from "api/Cache";
import { useCallback, useEffect, useState } from "react";
import { BreadCrumbs, ProjectCard, CacheDataLoader } from "components";
import { Scrollbars } from "react-custom-scrollbars";
import { Stack, CardContent, Button } from "@mui/material";
import { tss } from "tss-react";
import AddIcon from '@mui/icons-material/Add';
import { useDispatch } from 'react-redux';
import { resetProject } from 'store/projects';
import CreateProjectPanel from "panels/CreateProjectPanel/index";
import {
	openNewDialog,
	openEditDialog
} from 'store/projects';

export const useStyles = tss.create(() => ({
    scrolledContent: {
        margin: '0 !important'
    },
    newProjectButton: {
        backgroundColor: '#3B82F7', 
        color:'#fff',
        textTransform: 'uppercase'
    },
    topHeader: {
        justifyContent: "space-between",
        paddingRight: 50
    }
}));

const Projects = () => {
    const { classes } = useStyles();
    const { classes: common, cx } = commonStyles();
    const { classes: viewsClasses } = viewsStyles();
    const [data, setData] = useState<any>(null);
    const [projects, setProjects] = useState<any>([]);
    const [loaded, setLoaded] = useState<any>(false);
    const [newProject, setNewProject] = useState(false);
	const dispatch = useDispatch();

    const onDataLoad = useCallback((cacheData: any) => {
            if(loaded) return;

            setData(cacheData);
            cacheData["projects"] && setProjects(Object.entries(cacheData["projects"]).map((item: any) => item[1]));
            setLoaded(true);
    }, [data, setData, projects, setProjects, loaded, setLoaded]);
    
    useEffect(() => {
        dispatch(resetProject());
    }, []);

    return (
        <CacheDataLoader onDataLoad={onDataLoad}>
            <div className={viewsClasses.root}>
                <div className={cx(common.middle, viewsClasses.topHeader, classes.topHeader)}>
                    <BreadCrumbs label="My Projects" className='mainTitle' />
                    <div style={{display:"inline-flex"}}>
                        <div onClick={() => setNewProject(true)}>
                            <Button 
                                className={classes.newProjectButton} 
                                variant="contained" 
                                startIcon={<AddIcon  sx={{ fontSize: 25 }} />}
                                onClick={(ev: any) => {
									ev.stopPropagation();
									dispatch(openNewDialog(null));
								}}
                            >
                                Create Project
                            </Button>
                        </div>
                    </div>      
                </div>
                <div className={viewsClasses.content}>
                    <Scrollbars
                        autoHeight
                        autoHeightMax={"calc(100vh - 186px)"}
                        style={{ overflowX: "hidden"}}
                        renderView={(props: any) => <div {...props} className={classes.scrolledContent} />}
                    >
                        <Stack spacing={{ xs: 1, sm: 2, md: 4 }} direction="row" useFlexGap flexWrap="wrap" style={{ padding: "35px", alignItems: 'center'}}>
                            {projects.map((project: any, index: number) => (
                                <ProjectCard project={project} key={`projectcard-${project.ID}`} />
                            ))}
                        </Stack>
                    </Scrollbars>
                </div>
            </div>
            <CreateProjectPanel/>
        </CacheDataLoader>

        
    );
}

export default Projects;